import { LoginWithPopupAdapterInteractor } from '../../auth/domain/interactors/login-with-popup-adapter.interactor';
import { OAuthResponse } from '../../auth/domain/models/oauth-response.model';
import { GoogleIdentityService } from '../../common/google/google-identity.service';

export class LoginWithPopupGoogleAdapterInteractor implements LoginWithPopupAdapterInteractor {
  constructor(
    private readonly clientId: string,
    private readonly googleIdentityService: GoogleIdentityService,
    private readonly scopes: string[],
  ) {}

  public async execute(
    state: string,
    _pkceChallenge: string,
    _authTypeChanged: boolean,
  ): Promise<OAuthResponse> {
    await this.googleIdentityService.load();

    return new Promise((resolve, reject) => {
      const codeClientFlow = google.accounts.oauth2.initCodeClient({
        client_id: this.clientId,
        scope: this.scopes.join(' '),
        state,
        ux_mode: 'popup',
        callback: (response) =>
          resolve({
            code: response.code,
            state: response.state,
            error: response.error,
            metadata: {
              // TODO: Is there a way to retrieve `authuser` index?
              authuser: 0,
            },
          }),
        error_callback: () => reject(),
      });

      codeClientFlow.requestCode();
    });
  }
}
